module.exports = __webpack_public_path__ + "static/media/close.7aed224d.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/close.svg
// module id = 127
// module chunks = 0